import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { pathOr } from 'ramda';
import { connect } from 'react-redux';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MultiSelect } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import intlMessages from '../messages';

type Property = {
  id: string,
  name: string,
  isTwoWayCommunicationActive?: boolean,
};

type Props = {|
  selectedPropertyIds: string[],
  onChange: (propertyIds: string[]) => void,
  userProperties: Property[],
|};

function PropertyFilter({
  selectedPropertyIds,
  onChange,
  userProperties,
}: Props): React$Node {
  const options = useMemo(() => {
    const noTrainingProperties = userProperties.filter(
      (prop) => !prop.isTestProperty,
    );

    return noTrainingProperties
      .filter((property) => property.isTwoWayCommunicationActive === true)
      .map((property) => ({
        value: property.id,
        text: property.name,
      }));
  }, [userProperties]);

  const handleChange = (selectedValues: string[]) => {
    onChange(selectedValues);
  };

  return (
    <Box mb={2} width={300}>
      <MultiSelect
        value={selectedPropertyIds}
        onChange={handleChange}
        options={options}
        placeholder="All Properties"
        fullWidth
        label={<FormattedMessage {...intlMessages.filterByProperty} />}
      />
    </Box>
  );
}

const mapStateToProps = (state: any) => ({
  userProperties: pathOr(
    [],
    ['app', 'currentUser', 'user', 'properties'],
    state,
  ),
});

// $FlowFixMe - connect types not properly inferred
export default connect(mapStateToProps)(PropertyFilter);
